import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorDescription: {
		id: 'servicedesk-incident-management-settings.common.error-description',
		defaultMessage: "We're not quite sure what went wrong. Refresh the page if the error persists.",
		description: 'Generic error message shown to users.',
	},
	connectionToProjectEnabledSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.connection-to-project-enabled-success-flag-title',
		defaultMessage: 'Microsoft Teams enabled',
		description: 'The title for successful connection of workplace',
	},
	zoomConnectionToProjectEnabledSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-enabled-success-flag-title',
		defaultMessage: 'Zoom enabled',
		description: 'The title for successful connection of workplace to zoom',
	},
	connectionToProjectEnabledSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.common.connection-to-project-enabled-success-flag-text',
		defaultMessage: 'Agents can now create chats and meetings for incidents in this project.',
		description: 'The message content for successful connection of workplace',
	},
	zoomConnectionToProjectEnabledSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-enabled-success-flag-text',
		defaultMessage: 'Agents can now create meetings for incidents in this project.',
		description: 'The message content for successful connection of workplace to zoom',
	},
	connectionToProjectDisabledSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.connection-to-project-disabled-success-flag-title',
		defaultMessage: 'Microsoft Teams disabled',
		description: 'The title for error in connection of workplace',
	},
	zoomConnectionToProjectDisabledSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-disabled-success-flag-title',
		defaultMessage: 'Zoom disabled',
		description: 'The title for error in connection of workplace to zoom',
	},
	connectionToProjectDisabledSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.common.connection-to-project-disabled-success-flag-text',
		defaultMessage: 'Agents can’t create chats and meetings for incidents until you enable it.',
		description: 'The message content for error in connection of workplace',
	},
	zoomConnectionToProjectDisabledSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-disabled-success-flag-text',
		defaultMessage:
			'Agents can’t create meetings for incidents in this project until you enable it.',
		description: 'The message content for error in connection of workplace to zoom',
	},
	connectionToProjectErrorFlagText: {
		id: 'servicedesk-incident-management-settings.common.connection-to-project-error-flag-text',
		defaultMessage: 'Something went wrong, please try again? If you need help, contact support.',
		description: 'The message content for error in connection of workplace',
	},
	zoomConnectionToProjectEnabledErrorFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-enabled-error-flag-title',
		defaultMessage: 'We couldn’t enable Zoom',
		description: 'The title for failure of connection of workplace to zoom',
	},
	zoomConnectionToProjectDisabledErrorFlagTitle: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-disabled-error-flag-title',
		defaultMessage: 'We couldn’t disable Zoom',
		description: 'The title for error in disabling connection of workplace to zoom',
	},
	zoomConnectionToProjectEnabledErrorFlagText: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-enabled-error-flag-text',
		defaultMessage: 'Try enabling it again. If you need help, contact support.',
		description: 'The message content for error in connection of workplace to zoom',
	},
	zoomConnectionToProjectDisabledErrorFlagText: {
		id: 'servicedesk-incident-management-settings.common.zoom-connection-to-project-disabled-error-flag-text',
		defaultMessage: 'Try disabling it again. If you need help, contact support.',
		description: 'The message content for error in disabling connection of workplace to zoom',
	},
});
